module.exports = __webpack_public_path__ + "img/logo.d452cc5.svg";